import { useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { useTranslation } from '../../services/LanguageContext'; // Import useTranslation hook
import './faqPage.scss'; // Import CSS file for styling if needed

const FaqPage = () => {
    const { language, t } = useTranslation(); // Get translation hook
    const [faqs, setFaqs] = useState([]);
    const [translatedFaqs, setTranslatedFaqs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

     // Fetch FAQs based on selected language
    useEffect(() => {
        const fetchFaqs = async () => {            setLoading(true);
            
            try {
                // Convert language to lowercase for the locale parameter
                const locale = language.toLowerCase();
                
                // Add locale parameter to the API URL
                const apiUrl = `https://find-together-api.sslbeta.de/api/Support/getFAQs?locale=${locale}`;
                
                console.log(`Fetching FAQs for locale: ${locale} from ${apiUrl}`);
                
                const response = await fetch(apiUrl);
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const data = await response.json();
                
                // Validate the response data
                if (!Array.isArray(data)) {
                    throw new Error('Invalid response format: expected an array');
                }
                
                setFaqs(data);
                console.log(`Successfully loaded ${data.length} FAQs for locale: ${locale}`);
                
            } catch (error) {
                console.error('Error fetching FAQs:', error);
                
                // Set fallback FAQs if API fails
                const fallbackFaqs = language === 'DE' ? [
                    {
                        question: 'Wie kann ich mich registrieren?',
                        answer: 'Sie können sich über unsere mobile App registrieren, die im Google Play Store verfügbar ist.'
                    },
                    {
                        question: 'Ist die App kostenlos?',
                        answer: 'Ja, unsere App ist komplett kostenlos nutzbar mit minimaler Werbung.'
                    }
                ] : [
                    {
                        question: 'How can I register?',
                        answer: 'You can register through our mobile app, available on the Google Play Store.'
                    },
                    {
                        question: 'Is the app free?',
                        answer: 'Yes, our app is completely free to use with minimal advertising.'
                    }
                ];
                
                setFaqs(fallbackFaqs);
            } finally {
                setLoading(false);
            }
        };

        fetchFaqs();
    }, [language]); // Refetch when language changes

    // Filter FAQs based on search term
    const filteredFaqs = faqs.filter(faq =>
        faq.question.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className='container inner-page-container'>
            <div className="help-search">
                <h2>{t('faq_help_title', 'Brauchst du Hilfe?')}</h2>
                <input
                    type="text"
                    placeholder={t('faq_search_placeholder', 'Gib hier deine Frage ein...')}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="help-search-input"
                />
            </div>
            <h2 className='text-left my-5'>{t('faq_title', 'Häufig gestellte Fragen')}</h2>
            {loading ? (
                <p className='text-center'>{t('faq_loading', 'FAQs werden geladen...')}</p>
            ) : (
                <>
                    {filteredFaqs.length > 0 ? (
                        <Accordion>
                            {filteredFaqs.map((faq, index) => (
                                <Accordion.Item key={index} eventKey={index.toString()}>
                                    <Accordion.Header>{faq.question}</Accordion.Header>
                                    <Accordion.Body>{faq.answer}</Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    ) : (
                        <p className='text-center'>
                            {t('faq_no_results', 'Keine FAQs gefunden. Bitte besuchen Sie unsere')} 
                            <a href="/contact"> {t('faq_contact_link', 'Kontaktseite')}</a> 
                            {t('faq_support_text', ' für weitere Unterstützung.')}
                        </p>
                    )}
                </>
            )}
        </div>
    );
};

export default FaqPage;
